import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import ScrollableAnchor, { goToAnchor } from 'react-scrollable-anchor';
import BreadcrumbProduct from '../../components/BreadcrumbProduct';
import Tabs from '../../components/Tabs';
import ProductIntroduction from '../../components/ProductIntroduction';
import ProductInfo from '../../components/ProductInfo';
import ProductSpecs from '../../components/ProductSpecs';
import ProductFeature from '../../components/ProductFeature';
import { getItemById, isMobile } from '../../lib/util';
import './Product.css';

let lastQueryStr = '';

class Product extends Component {
  // componentDidMount() {
  //   if (this.props.match.params.id) {
  //     setTimeout(() => goToAnchor('product'), 300);
  //   }
  // }

  componentDidMount() {
    this.goToAnchorResults();
  }

  componentDidUpdate() {
    this.goToAnchorResults();
  }

  goToAnchorResults() {
    const queryStr = this.props.match.params.id;
    if (queryStr && lastQueryStr !== queryStr) {
      setTimeout(() => goToAnchor('product'), 300);
      lastQueryStr = queryStr;
    }
  }

  render() {
    const { match } = this.props;

    if (this.props.products.length === 0) {
      return null;
    }

    const product = getItemById({
      id: match.params.id * 1,
      array: this.props.products,
      key: 'product_ID',
    });
    const shouldRedirect = this.props.products.length > 0 && match.params.id && !product;

    const tabs = [];
    if (product) {
      const hasSpec = product.productspecifications && product.productspecifications.length > 0;
      const hasFeat = product.productfeatures && product.productfeatures.length > 0;
      if (hasSpec || hasFeat) {
        tabs.push({ title: '產品介紹', link: `/product/${match.params.id}`, stateIdentifier: null });
      }
      if (hasSpec) {
        tabs.push({ title: '產品規格', link: `/product/${match.params.id}/specs`, stateIdentifier: 'specs' });
      }
      if (hasFeat) {
        tabs.push({
          title: '產品特色',
          link: `/product/${match.params.id}/feature`,
          stateIdentifier: 'feature',
        });
      }
    }

    const { filter } = match.params;

    let Introduction;
    let IntroductionContent;
    if (isMobile()) {
      if (filter === 'specs') {
        IntroductionContent = <ProductSpecs product={product} {...this.props} />;
      } else if (filter === 'feature') {
        IntroductionContent = <ProductFeature product={product} {...this.props} />;
      } else {
        IntroductionContent = <ProductInfo product={product} />;
      }
      Introduction = (
        <ProductIntroduction {...this.props} product={product} products={this.props.products}>
          {tabs && tabs.length > 0 && <Tabs notToggle tabs={tabs} {...this.props} />}
          {IntroductionContent}
        </ProductIntroduction>
      );
    } else if (filter === 'feature') {
      Introduction = <ProductFeature product={product} {...this.props} />;
    } else {
      Introduction = (
        <ProductIntroduction {...this.props} product={product} products={this.props.products}>
          {product && filter === 'specs' ? (
            <ProductSpecs product={product} {...this.props} />
          ) : (
            <ProductInfo product={product} />
          )}
        </ProductIntroduction>
      );
    }

    return (
      <section className="section">
        <ScrollableAnchor id="product">
          <div className="product container">
            <BreadcrumbProduct product={product} {...this.props} />
            {!isMobile() && <Tabs tabs={tabs} {...this.props} />}
            <div className="outter-container">
              <div className="inner-container">{Introduction}</div>
            </div>
          </div>
        </ScrollableAnchor>
        {shouldRedirect && <Redirect to="/catalog/1" />}
      </section>
    );
  }
}

Product.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      filter: PropTypes.string,
      id: PropTypes.string,
    }),
  }),
};

Product.defaultProps = {
  match: {
    params: {
      filter: undefined,
      id: 1,
    },
  },
};

const mapStateToProps = state => ({
  products: state.products,
  categories: state.categories,
});

export default connect(mapStateToProps)(Product);



// WEBPACK FOOTER //
// ./src/containers/page/Product.js